import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from "../../Button";
import { IconSystemAdd } from "../../Icon";
import TextCallout1 from "../../textComponents/TextCallout1";
import { colors } from "../../../styleguide";
var AddButtonText = styled(TextCallout1).withConfig({
  displayName: "NewAdButton__AddButtonText",
  componentId: "sc-pxxxtz-0"
})(["color:", ";padding-left:8px;"], colors.white100);

var NewAdButton = function NewAdButton(_ref) {
  var adInsertUrl = _ref.adInsertUrl;
  return /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    size: "tiny",
    href: adInsertUrl,
    style: {
      marginLeft: '8px',
      marginRight: '8px'
    }
  }, /*#__PURE__*/React.createElement(IconSystemAdd, {
    color: colors.white100,
    width: 16,
    height: 16
  }), ' ', /*#__PURE__*/React.createElement(AddButtonText, null, "L\xE4gg in annons"));
};

NewAdButton.propTypes = process.env.NODE_ENV !== "production" ? {
  adInsertUrl: PropTypes.string.isRequired
} : {};
export default NewAdButton;
//# sourceMappingURL=NewAdButton.js.map